(function (angular){
    'use strict';

    angular.module('app')
        .controller('adminDashboardController', adminDashboardController);

    adminDashboardController.$inject = [
        'latestPollPayload'
    ];

    function adminDashboardController(
        latestPollPayload
    ) {
        var vm = this;

        // properties
        vm.latestPoll = latestPollPayload.data[0];
    }

}(angular));
